import React, { useState } from 'react';
import axios from 'axios';
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { toast } from "sonner";
import { LogOut, LayoutDashboard, Image } from "lucide-react";
import { useNavigate } from "react-router-dom";
import LeadsDashboard from "../components/admin/LeadsDashboard";
import GalleryManager from "../components/admin/GalleryManager";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Admin() {
  const [token, setToken] = useState(localStorage.getItem('admin_token'));
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${API}/api/login`, { password });
      if (res.data.success) {
        localStorage.setItem('admin_token', res.data.token);
        setToken(res.data.token);
        toast.success("Welcome back, Admin!");
      }
    } catch (err) {
      toast.error("Invalid Password");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setToken(null);
    navigate('/');
  };

  if (!token) {
    return (
      <div className="min-h-screen bg-neutral-950 flex items-center justify-center p-4">
        <Card className="w-full max-w-md bg-black border-neutral-800">
          <CardHeader>
            <CardTitle className="text-2xl text-white text-center">Admin Login</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleLogin} className="space-y-4">
              <div className="space-y-2">
                <Label className="text-neutral-400">Password</Label>
                <Input
                  type="password"
                  data-testid="admin-password-input"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  className="bg-neutral-900 border-neutral-800 text-white"
                />
              </div>
              <Button type="submit" data-testid="admin-login-btn" className="w-full bg-red-600 hover:bg-red-700">Login</Button>
            </form>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-950 text-white pt-24 pb-12" data-testid="admin-dashboard">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Admin Dashboard</h1>
          <Button variant="outline" onClick={handleLogout} data-testid="admin-logout-btn" className="border-red-600 text-red-600 hover:bg-red-900/20">
            <LogOut className="mr-2 h-4 w-4" /> Logout
          </Button>
        </div>

        <Tabs defaultValue="leads" className="w-full">
          <TabsList className="mb-8 bg-neutral-900 border border-neutral-800 p-1 h-auto">
            <TabsTrigger value="leads" data-testid="tab-leads" className="px-5 py-2 data-[state=active]:bg-red-600 data-[state=active]:text-white text-neutral-400 rounded-md flex items-center gap-2">
              <LayoutDashboard className="h-4 w-4" /> Leads & CRM
            </TabsTrigger>
            <TabsTrigger value="gallery" data-testid="tab-gallery" className="px-5 py-2 data-[state=active]:bg-red-600 data-[state=active]:text-white text-neutral-400 rounded-md flex items-center gap-2">
              <Image className="h-4 w-4" /> Gallery
            </TabsTrigger>
          </TabsList>

          <TabsContent value="leads">
            <LeadsDashboard token={token} />
          </TabsContent>
          <TabsContent value="gallery">
            <GalleryManager token={token} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
